import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Amount, ShowExpanded } from '../shared';
import DiscountDetails from './DiscountDetails';
import PriceTable from './PriceTable';

import './DiscountItem.less';

@observer class DiscountItem extends Component {
  constructor() {
    super();
    this.state = { expanded: false };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState(state => ({ expanded: !state.expanded }));
  }
  render() {
    const { expanded } = this.state;
    const { discount, contact } = this.props;
    const prices = discount.qty;
    let badge = null;
    let price = null;
    let details = null;

    if (expanded) {
      details = (
        <div>
          <PriceTable prices={prices} contact={contact} />
          <DiscountDetails discount={discount} />
        </div>
      );
    }

    if (prices.length > 1 || (prices.length === 1 && prices[0].qdQty !== 1)) {
      badge = <span className="badge">{prices.length}</span>;
    } else if (prices.length) {
      let amount = prices[0].qdVal;
      if (contact.credShow) {
        amount = prices[0].k1Calcpx;
      }
      price = <Amount amount={amount} />;
    }

    return (
      <div className="list-group-item">
        {badge}
        <div onClick={this.toggle}>
          <ShowExpanded expanded={expanded} />
          <span>
            {discount.artCode}
          </span>
          <span className="ship-mth">
            ({discount.shipMth.substr(0, 3)})
          </span>
          <span className="pull-right">
            {price}
          </span>
        </div>
        {details}
      </div>
    );
  }
}

export default DiscountItem;



// WEBPACK FOOTER //
// ./src/discounts/DiscountItem.js